import { UtilHelper } from '../../../../shared/helpers/utils.helper';
import { Translation } from '../../../../shared/models/translation.model';
import { ChargeOption } from '../enum/charge-option.enum';
import { ComplementOption } from './complement-options.model';

export class Complement {
  id: number;
  productId: number;
  name: string;
  chargeOption: ChargeOption;
  min: number = 0;
  max: number = 1;
  amount: number = 0;
  ordination: number;
  complementOptions: Array<ComplementOption>;

  // Aux view
  nameTranslations: Translation;

  private _mandatory: boolean;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (this.chargeOption != null && this.chargeOption['code'] == null) {
      this.chargeOption = UtilHelper.getEnumByCod(this.chargeOption, ChargeOption);
    } else if (this.chargeOption == null || this.chargeOption['code'] == null) {
      this.chargeOption = ChargeOption.SUM_TOTAL;
    }

    if (!this.complementOptions) {
      this.complementOptions = [];
    }
  }

  public incrementMin(): void {
    this.min++;
    if (this.min > this.max) {
      this.max = this.min;
    }
  }

  public decrementMin(): void {
    if (this.min !== 0) {
      this.min--;
    }
  }

  public incrementMax(): void {
    this.max++;
  }

  /**
   * Mínimo da quantidade máxima deve ser 1.
   */
  public decrementMax(): void {
    if (this.max >= 2) {
      this.max--;
    }
    if (this.max < this.min) {
      this.min = this.max;
    }
  }

  public addComplementOption(complementOptions: ComplementOption): void {
    this.complementOptions.push(complementOptions);
  }

  public get mandatory(): boolean {
    if (this.min !== 0) {
      this.mandatory = true;
    } else {
      this.mandatory = false;
    }

    return this._mandatory;
  }

  public set mandatory(value: boolean) {
    this._mandatory = value;
    if (value) {
      if (this.min === 0) {
        this.min = 1;
      }
    } else {
      if (this.min > 0) {
        this.min = 0;
      }
    }
  }

  toJson(): any {
    const data: any = {
      id: this.id,
      productId: this.productId,
      name: this.name,
      chargeOption: this.chargeOption['code'],
      min: this.min,
      max: this.max,
      mandatory: this.mandatory,
      ordination: this.ordination,
    };

    return data;
  }

  toReorderJson(): any {
    const data: any = {
      id: this.id || null,
      ordination: this.ordination,
    };
    return data;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/category/products/models/complement.model.ts